import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
  arrowBtn: {
    '& > span': {
      fontSize: 0,
    },
    flex: 1,
  },
  menuItem: {
    minHeight: 'auto!important',
  },
  currencyToggle: {
    paddingLeft: 20,

    '@media (max-width: 767px)': {
      paddingLeft: 6,
    },
  },
  wrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
    '@media (max-width:767px)': {
      width: '100%',
      gap: 16,
    },
    '@media (min-width:768px)': {
      width: 'max-content',
      justifyContent: 'flex-start',
    },
  }
});
